import * as z from "zod";

export const deleteShipbobIntegration = {
  name: "deleteShipbobIntegration" as const,
  input: z.object({ integrationId: z.string() }),
  output: z.object({}),
};
